(function () {
  const insuranceElements = document.querySelectorAll('.insurance-products');

  if (insuranceElements) {
    insuranceElements.forEach((element) => {
      const header = element.querySelector('.insurance-products__header');
      const list = element.querySelector('.insurance-products__list');

      header.addEventListener('click', function () {
        if (window.innerWidth < 700) {
          if (getComputedStyle(list).display === 'none') {
            list.style.display = 'flex';
            header.classList.add('expanded');
          } else {
            list.style.display = 'none';
            header.classList.remove('expanded');
          }
        }
      });
    });
  }
})();
